enum OrderTab {
    /**等待付款 */
    PENDING_PAYMENT = "PENDING_PAYMENT",
    /**待发货 */
    PENDING_SHIPMENT = "PENDING_SHIPMENT",
    /**挂起 */
    ON_HOLD = "ON_HOLD",
    /**待发货-退款中订单 */
    PENDING_SHIPMENT_REFUNDING = "PENDING_SHIPMENT_REFUNDING",
    /**已发货-退款中 */
    SHIPPED_REFUNDING = "SHIPPED_REFUNDING",
    /**预发货 */
    PRE_SHIP = "PRE_SHIP",
    /**已发货 */
    SHIPPED = "SHIPPED",
    /**已完成 */
    SUCCESS = "SUCCESS",

    /**已取消 */
    CANCELED = "CANCELED",
    /**异常 */
    ABNORMAL = "ABNORMAL",
    /**物流警告 */
    LOGISTICS_WARNING = "LOGISTICS_WARNING",
    /**发货后超时揽收预警 */
    PICKUP_DEADLINE_WARNING = "PICKUP_DEADLINE_WARNING",
}

export default OrderTab;
